// Performance optimization: Avoid using new URL() where possible
// This utility is used frequently in image processing loops
export const toCdn = (u: string) => {
	// S3 bucket URL parts
	const s3Host = "settlin.s3.ap-south-1.amazonaws.com";
	const cdnHost = "media.settlin.in";

	// Fast path: string replacement for standard URLs
	// Most common case: https://settlin.s3.../path
	// We must ensure the host is followed by a path separator or end of string
	const httpsPrefix = "https://" + s3Host;
	if (u.startsWith(httpsPrefix)) {
		const rest = u.slice(httpsPrefix.length);
		if (!rest || rest.startsWith("/") || rest.startsWith("?") || rest.startsWith("#")) {
			return "https://" + cdnHost + rest;
		}
	}

	// Fast path for http
	const httpPrefix = "http://" + s3Host;
	if (u.startsWith(httpPrefix)) {
		const rest = u.slice(httpPrefix.length);
		if (!rest || rest.startsWith("/") || rest.startsWith("?") || rest.startsWith("#")) {
			return "http://" + cdnHost + rest;
		}
	}

	// Legacy/Edge cases:
	// If it doesn't match the fast path (e.g. mixed case) we use regex.
	// This avoids new URL() overhead which is ~200x slower.
	// Enforce boundary check after hostname.
	const match = u.match(/^(https?:\/\/)(settlin\.s3\.ap-south-1\.amazonaws\.com)([\/?#]|$)/i);
	if (match) {
		// match[1] is protocol
		// match[2] is hostname
		// match[3] is the separator (or empty string if end)
		// We need to replace match[2] with cdnHost and keep everything else

		// To correctly reconstruct, we can just replace the first occurrence of match[2]
		// or construct strictly from pieces if we parsed more.
		// A simpler regex approach for replacement:
		return u.replace(match[2], cdnHost);
	}

	return u;
};
